<template>
  <div>
    <DropDown v-model="fieldValue" filter :options="options" optionLabel="label" optionValue="id"
              :disabled="disabled"></DropDown>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "DynamicDropDown",
  props: ['uniqueId', 'options', 'disabled'],
  data() {
    return {
      // fieldValue: null
    }
  },
  computed: {
    ...mapGetters('search', [
      'getData'
    ]),
    fieldValue: {
      get() {
        return this.getData(this.uniqueId)[0];
      },
      set(data) {
        this.setData({uniqueId: this.uniqueId, data: [data]})
      }
    },
  },
  methods: {
    ...mapActions('search', [
      'setData'
    ]),
  },

}
</script>

<style scoped>

</style>